import { useEffect } from "react"
import DistrictMasterForm from "./DistrictMasterForm"


const DistrictMaster = ({ open }) => {
    useEffect(() => {
        document.title = 'District Master'
    }, [])
    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <DistrictMasterForm />
        </main>
    )
}
export default DistrictMaster;